// extracted by mini-css-extract-plugin
export default {"image":"iX-z","loaded":"jX-z"};